export const prixRemiseTotalProps = () => ({
  article: {
    type: Object,
    required: true
  }
})

export const usePrixRemiseTotal = (props) => {
  const prixTotalRemise = computed(() => {
    if (props.article.quantite > 6) {
      return (parseFloat(props.article.prix_avec_remise_sans_appel_fidelite) * 6 + (props.article.quantite - 6) * parseFloat(props.article.prix))
    } else {
      return (parseFloat(props.article.prix_avec_remise_sans_appel_fidelite) * props.article.quantite)
    }
  })

  return { prixTotalRemise };
}